module.exports = __webpack_public_path__ + "img/delegate.6a99649a.svg";